import * as React from 'react'
import { historyState } from '../../../store/historyState.ts'
import { useSnapshot, ref } from 'valtio'
import { dayHistoryState, resetDayHistory } from '../../../store/dayHistoryState.ts'
import { controlState } from '../../../store/controlState.ts'
import { dataState } from '../../../store/dataState.ts'
import { deviceFromPet } from '../../../helpers/dataHelpers.ts'
import { fetchDayHistory } from '../../../helpers/dayHistoryHelper.ts'
import { DateTime } from 'luxon'
import { effectiveTimezone } from '../../../store/authState.ts'

export const HistoryToggles: React.FC = () => {
    const showSafeZones = (useSnapshot(historyState) as typeof historyState).showSafeZones
    const includeInvalid = (useSnapshot(historyState) as typeof historyState).includeInvalid
    const isMobile = useSnapshot(controlState).isOnMobileDevice
    const dayHistoryActive = (useSnapshot(dayHistoryState) as typeof dayHistoryState).active
    const dayHistoryLoading = (useSnapshot(dayHistoryState) as typeof dayHistoryState).loading

    const paddingTop = isMobile ? 'pt-[3px]' : 'pt-[5px]'

    const toggleDayHistory = async () => {
        const store = dayHistoryState

        if (store.active) {
            // Exit day history mode
            resetDayHistory()
            return
        }

        // Enter day history mode
        const selectedPetId = historyState.selectedPetId
        if (!selectedPetId) return

        const pets = dataState.pets
        const pet = pets.find(p => p._id === selectedPetId)
        if (!pet) return

        const device = deviceFromPet(pet)
        if (!device) return

        store.active = true
        store.loading = true

        // Use today in the user's timezone as the starting point for Day History.
        // We don't use historyStore.endDate because it's in the browser's local timezone
        // and zone-converting it can shift to the wrong calendar day.
        const tz = effectiveTimezone()
        const zone = tz.value
        const date = DateTime.now().setZone(zone)

        store.selectedDate = ref(date) as unknown as DateTime
        const data = await fetchDayHistory(device.iccid, pet._id, date)

        if (data) {
            store.pathData = data
            store.error = ''
        } else {
            store.error = 'Failed to load day history'
        }
        store.loading = false
    }

    return (
        <div className={'flex items-center gap-2'}>
            {!isMobile && (
                <button
                    className={`btn btn-xs ${dayHistoryActive ? 'btn-secondary' : 'btn-outline btn-secondary'} ${paddingTop}`}
                    onClick={() => void toggleDayHistory()}
                    disabled={dayHistoryLoading}
                >
                    {dayHistoryLoading ? (
                        <span className="loading loading-spinner loading-xs"></span>
                    ) : 'Day History'}
                </button>
            )}
            {!dayHistoryActive && (
                <>
                    <button
                        className={`btn btn-xs ${showSafeZones ? 'btn-primary' : 'btn-outline btn-primary'} ${paddingTop}`}
                        onClick={() => historyState.showSafeZones = !showSafeZones}
                    >
                        Safe Zones
                    </button>
                    {!isMobile && (
                        <button
                            className={`btn btn-xs ${!includeInvalid ? 'btn-primary' : 'btn-outline btn-primary'} ${paddingTop}`}
                            onClick={() => historyState.includeInvalid = !includeInvalid}
                        >
                            Valid GPS Only
                        </button>
                    )}
                </>
            )}
        </div>
    )
}
